import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { v4 as uuidv4 } from "uuid";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import Status from "../../Status";
import moment from "moment";

function ReporteCostosCortes() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS_CORTES = process.env.REACT_APP_URL_ARTICULOS_CORTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [totalCantidad, setTotalCantidad] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

useEffect(() => {
  fetchCostos(); // solo corre al montar, no depende de las fechas
}, []);

const fetchCostos = () => {
  axios
    .get(`${URL_ARTICULOS_CORTES}CostosFechas/${selectedFechaInicio}/${selectedFechaFin}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allCortes = response.data;

      let arrayTabla = allCortes
        .sort((a, b) => (a.corte > b.corte ? 1 : -1))
        .map((a) => ({
          pedido: a.pedido,
          articulo: a.articulo,
          cantidad: a.cantidad,
          tela: a.tela,
          habilitacion: a.habilitacion,
          procesos: a.procesos,
          total: a.total,
          totalPorPieza: a.totalPorPieza,
          corte: a.corte,
          fecha: a.fecha,
        }))
        .filter((el) => el != null);

      setComments(arrayTabla);
    })
    .catch((err) => {
      console.log(err);
    });
};



  function PDFTabla() {
    const data = comments.map((a) => { {
        return [
          a.corte,
          a.fecha,
          a.pedido,
          a.articulo,
          new Intl.NumberFormat("en-US", {maximumFractionDigits: 0}).format(a.cantidad),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.tela),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.habilitacion),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.procesos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPorPieza)
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Articulos Costos Cortes`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Corte",
          "Fecha",
          "Pedido",
          "Articulo",
          "Cantidad",
          "Tela",
          "Habilitacion",
          "Procesos",
          "Total",
          "Total Por Pieza",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      // foot: [
      //   [
      //     "",
      //     "",
      //     "",
      //     "",
      //     "",
      //     "",
      //     "Total",
      //     new Intl.NumberFormat("en-US", {
      //       style: "currency",
      //       currency: "USD",
      //       maximumFractionDigits: 2,
      //     }).format(totalCantidad),
      //   ],
      // ],
      // showFoot: "lastPage",
    });
    // doc.save(`Cortes.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
        return {
          Corte: a.corte,
          Fecha: a.fecha,
          Pedido: a.pedido,
          Articulo: a.articulo,
          Cantidad: a.cantidad,
          Tela: a.tela,
          Habilitacion: a.habilitacion,
          Procesos: a.procesos,
          Total: a.total,
          "Total Por Pieza": a.totalPorPieza
        };
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ReporteCostosCortes";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ReporteCostosCortes",
        sheetFilter: [
          "Corte",
          "Fecha",
          "Pedido",
          "Articulo",
          "Cantidad",
          "Tela",
          "Habilitacion",
          "Procesos",
          "Total",
          "Total Por Pieza",
        ],
        sheetHeader: [
          "Corte",
          "Fecha",
         "Pedido",
          "Articulo",
          "Cantidad",
          "Tela",
          "Habilitacion",
          "Procesos",
          "Total",
          "Total Por Pieza",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  const headers = [
    { name: "Corte", field: "corte", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Pedido", field: "pedido", sortable: true },
    { name: "Articulo", field: "articulo", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Tela", field: "tela", sortable: true },
    { name: "Habilitacion", field: "habilitacion", sortable: true },
    { name: "Procesos", field: "procesos", sortable: true },
    { name: "Total", field: "total", sortable: true },
    { name: "Total Por Pieza", field: "totalPorPieza", sortable: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          String(comment.articulo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.pedido ?? "").includes(search) ||
          String(comment.cantidad ?? "").includes(search) ||
          String(comment.corte ?? "").includes(search) ||
          String(comment.tela ?? "").includes(search) ||
          String(comment.habilitacion ?? "").includes(search) ||
          String(comment.procesos ?? "").includes(search) ||
          String(comment.total ?? "").includes(search) ||
          String(comment.totalPorPieza ?? "").includes(search)
      );
    }

    // if (selectedFechaInicio) {
    //   computedComments = computedComments.filter(
    //     (e) => e.fecha >= selectedFechaInicio
    //   );
    // }

    // if (selectedFechaFin) {
    //   computedComments = computedComments.filter(
    //     (e) => e.fecha <= selectedFechaFin
    //   );
    // }

    let cant = computedComments.map((c) => parseFloat(c.cantidad));
    let TCant = cant.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalCantidad(TCant);


    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "pedido" &&
      sorting.field != "corte" &&
      sorting.field != "tela" &&
      sorting.field != "habilitacion" &&
      sorting.field != "procesos" &&
      sorting.field != "total" &&
      sorting.field != "totalPorPieza" 
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "pedido" ||
        sorting.field == "corte" ||
        sorting.field == "tela" ||
        sorting.field == "habilitacion" ||
        sorting.field == "procesos" ||
        sorting.field == "total" ||
        sorting.field == "totalPorPieza")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "pedido" ||
        sorting.field == "corte" ||
        sorting.field == "tela" ||
        sorting.field == "habilitacion" ||
        sorting.field == "procesos" ||
        sorting.field == "total" ||
        sorting.field == "totalPorPieza")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    // selectedFechaInicio,
    // selectedFechaFin,
  ]);

  return (
    <>
      <Header />
      <br />
      <br />
      {user.reporteCostosCortes ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuProduccion"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <h3 align="center">Articulos Costos Cortes</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
            <Button
  size="sm"
  color="info"
  onClick={fetchCostos}
>
  Actualizar Fechas
</Button>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                return(
                    <tr>
                      <td>{a.corte}</td>
                      <td>{a.fecha}</td>
                      <td>{a.pedido}</td>
                      <td>{a.articulo}</td>
                      <td>{new Intl.NumberFormat("en-US", {maximumFractionDigits: 0}).format(a.cantidad)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.tela)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.habilitacion)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.procesos)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPorPieza)}</td>
                    </tr>
                    )
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      {loader}
    </>
  );
}

export default ReporteCostosCortes;
